
<template>
    <div>
                <!-- <base-header style="background: #ffffff;background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 25%);" class="pb-6 pb-8 pt-4 pt-md-5 "> -->
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        <!-- </base-header> -->


        <div class="container-fluid mt--5" dir="ltr">
            <div class="row">
                <div class="col">
                          
                          <card id = "headerDescription"header-classes="bg-white" style="background-color: white;background: #fff;height:50px;">
                                      <div class="row" style="margin-top:-13px;">
                                        <div class="col-md-2">
                                            <base-button class="btn-primary btn-sm" style="margin-top:-20px;" v-on:click="back">{{texts.back}}</base-button>
                                            <base-button class="btn-primary btn-sm" type="primary" id="expandBtn" style="margin-top:-20px;" v-on:click="expandHeader">&#x25BC;</base-button>
                                        </div>
                                        <div class="col-md-6" v-if="language=='ltr'" style="margin-top:-20px">
                                      <h4  dir="rtl" >{{title}}</h4>
                                      
                                      <!-- <button type="button" class="collapsible">Open Collapsible</button> -->
                          <!-- <div class="content"> -->
                                      <h6  style="margin-top:-5px;color:#505050">{{description_display}}<span style="margin-left:50px;color:#000;"><b>{{date}}</b></span></h6>
                                    <!-- </div> -->
<!-- <div class="col-md-1"> -->
                                        
                                      <!-- </div> -->
                                      </div>
                                      <!-- <div class="col-md-6" v-else style="text-align:right;margin-top:-20px">
                                        <h3  dir="rtl" >{{title}}</h3>
                                        <h6 style="margin-top:-5px;color:#505050"><span style="margin-right:100px;">{{date}}</span>{{description}}</h6>
                                        </div> -->
                                       
                                      </div>
                                      <a :href="pdf_url"  style="float: right; width: 100%;margin-top:-57px;height:40px;" class="btn btn-primary btn-sm col-2" target="_blank">{{texts.downloadreport}}</a>
                                      
                                      <div class="row">




                                        <!-- <br> -->
                                     <!--    <span class="col-12" style="margin-top:-10px;" v-if="language=='ltr'">{{description}}<br></span>
                                        <span class="col-12" style="margin-top:-10px;text-align:right;" v-else >{{description}}<br></span>

                                        <br>

                                        <span class="col-12" style="margin-bottom:-20px;" v-if="language=='ltr'">{{date}}</span>
                                        <span class="col-12" style="margin-bottom:-20px;text-align:right;" v-else>{{date}}</span> -->

                                      </div>
                                    </card>
                    <div class="row">
                      <div class="col-md-8">
                        <div id="pdfdisplay" style="height: 1000px;"></div>
                        </div>
                        <div class="col-md-4" style="">
                          <card header-classes="bg-white" style="background-color: white;background: #fff;position: -webkit-sticky;
  position: sticky;  top: 0;">
                        <template slot="header" v-if="language =='ltr'">
                          <div class="row" style="margin-top:-15px;">
                          <div class="col-md-7">
                          <h2>{{texts.inquiry}}</h2>
                          </div>
                          <div class="col-md-5">
                          <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && enquirySelected" v-on:click="viewPrivateInquiries">{{texts.privateinquiries}}<badge type="white"></badge></base-button>
                          <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && !enquirySelected" v-on:click="viewPrivateInquiries">{{texts.publicinquiries}}<badge type="white"></badge></base-button>
                          </div>
                          </div>
                           <!-- <span style="font-size: 18px; color: black;width:85%;" id="exampleModalLabel">{{texts.inquiry}}</span> -->
                        </template>
                        <template slot="header" v-else dir="rtl">
                          <div class="row" style="margin-top:-15px;">
                            <div class="col-md-5">
                            <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && enquirySelected" v-on:click="viewPrivateInquiries">{{texts.privateinquiries}}<badge type="white"></badge></base-button>
                            <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && !enquirySelected" v-on:click="viewPrivateInquiries">{{texts.publicinquiries}}<badge type="white"></badge></base-button>
                            </div>
                          <div class="col-md-7" style="text-align : right;">
                          <h2>{{texts.inquiry}}</h2>
                          </div>

                          </div>
                           <!-- <span style="font-size: 18px; color: black;width:85%;" id="exampleModalLabel">{{texts.inquiry}}</span> -->
                        </template>
                        <!-- <div> -->

                        <div style="height:90%;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="!showEnquiry">
                          <card v-for="chat in private_inquiries" header-classes="bg-white" style="background-color: white;background: #fff;margin-bottom:15px;" >
                            <div class="row" style="margin-top:-20px;">

                              <!-- <div  class="col-md-1" style="margin-top:-12px;">
                              <badge  type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">!</badge>
                              </div> -->

                              <div class="col-md-8" style="margin-top:3px;">
                                <h3 >{{chat.title}}</h3>
                              </div>

                              <div class="col-md-4" style="margin-top:-10px;">
                                <button type="button" style="float: right;margin-top: 10px;" class="btn btn-success btn-sm" v-on:click="inquiryClicked(chat)">{{texts.view}}   <badge type="white"></badge></button>
                              </div>

                                <!-- </div> -->
                              <!-- <br> -->
                              <!-- <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
                              <br>
                              <br>
                              <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

                              <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span> -->
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <span style="font-size:14px;">
                                  {{chat.last_message.message}}
                                </span>
                              </div>
                            </div>

                            <div class="row" style="margin-bottom:-15px;">
                              <div class="col-md-12">
                                <span style="font-size:12px;">
                                  {{chat.last_message.datetime}}
                                </span>
                              </div>
                            </div>
                          </card>
                          <!-- <div v-for="(r, pos) in inquiries">
                         <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " ><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
                         <br>
                         </div> -->
                        </div>

                        <div style="/*overflow-y: scroll; height:200px;*/height:200px;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="inquiries.length > 0 && showEnquiry">

                          <div v-for="(r, pos) in inquiries">
                         <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " v-if="language=='ltr'"><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
                         <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; text-align:right;" v-else ><span style="color:#000;font-weight: bold; text-align:right;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:left;">{{r.datetime}}</div></div>
                         <br>
                         </div>
                        </div>
                        <div v-if="showEnquiry">
                          <br>
                        <textarea v-if="language == 'ltr'" class="form-control"  placeholder="Inquiry.."
                                         type="text"
                                         v-model="inquiry_message" rows="6"
                                         >
                             </textarea>
                             <textarea v-else style="text-align:right;" class="form-control"  placeholder=" ..استفسار"
                                              type="text"
                                              v-model="inquiry_message" rows="6"
                                              >
                                  </textarea>

                        </div>

                        <div class="row" v-if="userType == 'committee' && showEnquiry && !isPrivateInquiry">
                          <!-- <div class="col-md-6">
                            <base-checkbox v-model="is_public" >{{texts.public}}</base-checkbox>
                          </div> -->
                          <div class="col-md-8" style="margin-bottom:-25px;">
                            <base-checkbox v-model="is_private">{{texts.private}}</base-checkbox>
                          </div>
                          <!-- <div class="col-md-8">
                            <div class="avatar-group">
                              <span href="#" class="avatar avatar-sm rounded-circle myDIV" data-toggle="tooltip" data-original-title="Ryan Tompson"
               v-b-tooltip.hover.left title="Tooltip on left">
                                <img alt="Image placeholder" src="img/theme/team-1-800x800.jpg">

                              </span>
                              <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Romina Hadid">
                                <img alt="Image placeholder" src="img/theme/team-2-800x800.jpg">
                              </span>
                              <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Alexander Smith">
                                <img alt="Image placeholder" src="img/theme/team-3-800x800.jpg">
                              </span>
                              <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Jessica Doe">
                                <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg">
                              </span>
                            </div>
                          </div> -->

                        </div>

                        <template slot="footer" v-if="showEnquiry">
                          <!-- <div class="row"> -->
                            <!-- <div class="col-md-4">
                            <base-button type="secondary" @click="modals.modalinquirybox = false;">{{texts.close}}</base-button>
                            </div> -->
                            <!-- <br> -->
                            <!-- <div class="col-md-1"> -->
                            <base-button type="primary" @click="sendInquiry()" style="width:100%;height:60px;">{{texts.send}}</base-button>
                            <!-- </div> -->
                            <!-- </div> -->
                            <!-- <base-button v-if="isManager" @click="approveMinutes()" type="primary">{{texts.approveminutes}}</base-button> -->

                        </template>
                        <!-- </div> -->
                        </card>
                        </div>
                      </div>
                    </div>

                <!-- </div> -->
            </div>
        </div>

        <!-- <div style="z-index: 1;position: relative;">
          <base-button class="btn-primary"  icon="ni ni-chat-round" style='position: fixed;bottom: 27px;right: 15px;height:44px;border-radius:15px;font-size:15px;background-color: #00a8ff;' v-on:click="openInquiryBox">{{texts.inquiry}}</base-button>
        </div> -->
         <!-- <div>
          <beautiful-chat style="z-index: 1;position: relative" v-if="isChatHidden" id="chat"
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="false"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            v-on:onType="handleOnType"
            v-on:edit="editMessage" />
        </div> -->


        <modal :show.sync="modals.modalinquirybox">
        <template slot="header">
           <span style="font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{texts.inquiry}}</span>
        </template>
        <div style="overflow-y: scroll; height:200px;" v-if="inquiries.length > 0">

          <div v-for="(r, pos) in inquiries">
         <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " v-if="language == 'ltr'"><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
         <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " v-else><span style="color:#000;font-weight: bold;text-align : right;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:left;">{{r.datetime}}</div></div>
         <br>
         </div>
        </div>
        <div>
          <br>
        <textarea v-if="language == 'ltr'" class="form-control"  placeholder="Inquiry.."
                         type="text"
                         v-model="inquiry_message" rows="6"
                         >
             </textarea>
             <textarea v-else class="form-control"  placeholder="استفسار .."
                              type="text"
                              v-model="inquiry_message" rows="6"
                              >
                  </textarea>

        </div>

        <div class="row" v-if="userType == 'committee' && inquiry_id.length ==0">
          <div class="col-md-4">
            <base-checkbox v-model="is_public" >{{texts.public}}</base-checkbox>
          </div>
          <div class="col-md-4" v-if="userType == 'committee'">
            <base-checkbox v-model="is_private">{{texts.private}}</base-checkbox>
          </div>

        </div>

        <template slot="footer">
            <base-button type="secondary" @click="modals.modalinquirybox = false;">{{texts.close}}</base-button>
            <base-button type="primary" @click="sendInquiry()" style="width:350px;">{{texts.send}}</base-button>
            <!-- <base-button v-if="isManager" @click="approveMinutes()" type="primary">{{texts.approveminutes}}</base-button> -->

        </template>
       </modal>


        <modal id="chatsModal" :show.sync="modals.modal9" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;" id="exampleModalLabel">{{texts.inquiries}}</span>
        </template>
          <div>
            <card v-for="chat in public_inquiries" header-classes="bg-white" style="background-color: white;background: #fff;" >
              <div class="row">
                <div v-if="chat.notifications > 0" class="col-1" style="margin-top:-12px;">
                <badge  type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">!</badge>
                </div>

                <h2 class="col-7" style="margin-top:-10px;">{{texts.publicinquiries}}</h2><div class="col-4"  style="width: 100%; margin-top:-15px;">

                <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary" v-on:click="inquiryClicked(chat)">{{texts.view}}</button>

                  </div>
                <!-- <br> -->
                <!-- <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
                <br>
                <br>
                <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

                <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span> -->
              </div>
            </card>
          </div>
          <br>
          <div v-if="private_inquiries.length > 0">
          <h3>{{texts.privateinquiries}}</h3>
          <div style="overflow-y: scroll; height:300px;">
          <card v-for="chat in private_inquiries" header-classes="bg-white" style="background-color: white;background: #fff;" >
            <div class="row">
              <div v-if="chat.notifications > 0" class="col-1" style="margin-top:-12px;">
              <badge  type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">!</badge>
              </div>

              <h2 class="col-7" style="margin-top:-10px;">{{chat.name}}</h2><div class="col-4"  style="width: 100%; margin-top:-15px;">

              <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary" v-on:click="inquiryClicked(chat)">{{texts.view}}</button>

                </div>
              <!-- <br> -->
              <!-- <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
              <br>
              <br>
              <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

              <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span> -->
            </div>
          </card>



        </div>
        </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="secondary" @click="modals.modal9 = false" style="margin-left:50px;">{{texts.close}}</base-button>
            <base-button v-if="userType == 'committee'" type="primary" @click="modals.modal9 = false;newPrivateInquiry();" style="margin-left:50px;">{{texts.newprivateinquiry}}</base-button>
        </template>
       </modal>

    </div>
</template>

<script>
  import ProjectsTable from './Tables/ProjectsTable';
  import { mapState } from "vuex";
  import { API_URL } from "@/common/config.js";
  import { GET_DELIVERABLE_FILE, CREATE_CHAT, GET_CHATS, SEND_MESSAGE, GET_DELIVERABLES, SEND_INQUIRY, GET_INQUIRIES,GET_ALL_INQUIRIES, GET_PRIVATE_INQUIRIES, GET_INQUIRY_BY_ID } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { mapGetters } from "vuex";
  import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
  import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
  import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
  import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
  import PDFObject from 'pdfobject';
  import UserService from "@/common/user.service";
  import JwtService from "@/common/jwt.service";
  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker, ProjectsTable},
    data() {
      return {
        isPrivateInquiry : false,
        enquirySelected : true,
        showEnquiry : true,
        title : '',
        description : '',
        description_display :'',
        isExpanded : false,
        date : '',
        self : this,
        pdf_url : '',
        file_location : '',
        texts : {
          downloadreport : UserService.getLanguage() === "rtl" ? "تنزيل التقرير": "Download Report",
          back : UserService.getLanguage() === "rtl" ? "رجوع" : "Back",
          close : UserService.getLanguage() === "rtl" ? "إغلاق" : "Close",
          chats : UserService.getLanguage() === "rtl" ? "محادثات" : "Chat",
          view : UserService.getLanguage() === "rtl" ? "عرض" : "View",
          publicchat : UserService.getLanguage() === "rtl" ? "محادثة عامة" : "Public Chat",
          privatechat : UserService.getLanguage() === "rtl" ? "محادثة خاصة" : "Private Chat",
          inquiry : UserService.getLanguage() === "rtl" ? "استفسار" : "Inquiry",
          send : UserService.getLanguage() === "rtl" ? "إرسال" : "Send",
          private : UserService.getLanguage() === "rtl" ? "شمل ممثلو العميل الآخرين" : "Include Other Client Representatives",
          public : UserService.getLanguage() === "rtl" ? "عام" : "AIGC team",
          publicinquiries : UserService.getLanguage() === "rtl" ? "استفسارات عامة" : "Public Inquiries",
          privateinquiries : UserService.getLanguage() === "rtl" ? "استفسارات خاصة" : "Private Inquiries",
          inquiries : UserService.getLanguage() === "rtl" ? "استفسارات" : "Inquiries",
          newprivateinquiry : UserService.getLanguage() === "rtl" ? "استفسار خاص جديد" : "New Private Inquiry"
        },
        inquiry_id : "",
        inquiry_message : "",
        isChatHidden : true,
        chats : [],
        isNewChat : false,
        chatId : "",
        chatType : "",
        chatTitle : "",
        inquiries : [{},{},{}],
        is_public : false,
        is_private : true,
        modals: {
          modal9 : false,
          modalinquirybox : false
        },
        userType : JwtService.getUserType(),
        language : UserService.getLanguage() || "ltr",
        dates: {
          simple: new Date().toISOString().split(" ")[0]
        },
              icons:{
        open:{
          img: OpenIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
      public_inquiries : [],
      private_inquiries : [],
      participants: [
        // {
        //   id: 'user1',
        //   name: 'Othman Barakat',
        //   imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        // },
        // {
        //   id: 'user2',
        //   name: 'Nasser Barakat',
        //   imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        // }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
      messageList: [
          // { type: 'text', author: `me`, data: { text: `Regarding the risk assessment report for phase 1, why is there a lack of documentation about the reported case on page 4 ?`,  meta: '06-16-2019 12:43' } },
          // { type: 'text', author: `user1`, data: { text: `Dear Mr. Ahmad, we have looked into your enquiry and found that indeed there was a lack of documentation. We shall update the report.` } }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      suggestions: ['some quick reply', 'another one'],
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4f2f81'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true
      }
    },
     computed: {
        ...mapGetters(["isAuthenticated", "overview"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
      watch: {
        is_public : function(oldVal, newVal) {
          if (oldVal && this.is_private) {
            this.is_private = false;
          }
        },
        is_private : function(oldVal, newVal) {
          if (oldVal && this.is_public) {

            this.is_public = false;
          }
        }
      },
    mounted() {
//       var coll = document.getElementsByClassName("collapsible");
// var i;

// for (i = 0; i < coll.length; i++) {
//   coll[i].addEventListener("click", function() {
//     this.classList.toggle("active");
//     var content = this.nextElementSibling;
//     if (content.style.display === "block") {
//       content.style.display = "none";
//     } else {
//       content.style.display = "block";
//     }
//   });
// }
      Promise.all([
        store.dispatch(GET_DELIVERABLES, [this.$route.params.entity, this.$route.params.phase])
      ]).then((data) => {

        // console.log(data[0]['data']);
          let deliverables = data[0]['data']['deliverables'];
          let token = this.$route.params.token;
          for (let y = 0; y < deliverables.length; y++) {
            // console.log(String(deliverables[y]._id),String(token))
            if (String(deliverables[y]._id) === String(token)) {
              this.title = deliverables[y].title;
              this.description = deliverables[y].description;
              this.description_display = this.description.substring(0,50) + "...";
              this.date = deliverables[y].date.split("-")[0] + "/" + deliverables[y].date.split("-")[1] + "/" + deliverables[y].date.split("-")[2];
              break;
            }

          }
        });

      this.pdf_url = API_URL + GET_DELIVERABLE_FILE+"/" + this.$route.params.token;
      PDFObject.embed(API_URL + GET_DELIVERABLE_FILE+"/" + this.$route.params.token, "#pdfdisplay");



      Promise.all([
        store.dispatch(GET_INQUIRIES,this.$route.params.token)
      ]).then((data) => {
        console.log(data);
        if (data[0]['errFlag'] == 0) {
          this.inquiries = data[0]['inquiry_messages'];
        }
      });

      Promise.all([
        store.dispatch(GET_PRIVATE_INQUIRIES,this.$route.params.token)
      ]).then((data) => {
        console.log(data);
        if (data[0]['errFlag'] == 0) {
          this.private_inquiries = data[0]['data'];
        }
      });

      // document.getElementById("chatsModal").childNodes[0].style = 'margin-right : 75px;background-color: #ffffff;';
      // document.getElementById("chat").style.visibility = "hidden";
      // document.getElementById("chat").childNodes[0].style="margin-right:125px;background-color: rgb(79, 47, 129);";
      // document.getElementById("chat").childNodes[0].childNodes[0].style="margin-right:125px;";
      // document.getElementById("chat").childNodes[0].childNodes[1].style="margin-right:125px;";

      // if (this.userType === "committee") {
      //   this.participants = [{"id" : "1234", "name" : "AIGC Team", "imageUrl" : "https://cdn.iconscout.com/icon/free/png-256/user-avatar-contact-portfolio-personal-portrait-profile-6-5623.png"}];
      // }
      // else {
      //   this.participants = [{"id" : "1234", "name" : "Committee Members", "imageUrl" : "https://cdn.iconscout.com/icon/free/png-256/user-avatar-contact-portfolio-personal-portrait-profile-6-5623.png"}];
      // }



      // Promise.all([
      //   store.dispatch(GET_INQUIRIES, "5e7f9e4e012ce7b1c996bcaa")
      // ]).then((data) => {
      //   console.log(data);
      //   if (data[0]['errFlag'] == 0) {
      //     this.inquiries = data[0]['inquiry_messages'];
      //   }
      // });



      //   console.log(data[0]['data']);
      //     // this.file_location = data[0]['data']['deliverables'];
      //     // this.very_high_findings = data[0]['data']['very_high_findings'];
      //     // this.high_findings = data[0]['data']['high_findings'];
      //     // this.medium_findings = data[0]['data']['medium_findings'];
      //     // this.low_findings = data[0]['data']['low_findings'];
      //     // this.very_low_findings = data[0]['data']['very_low_findings'];
      //     // this.percentages = data[0]['data']['percentages'];
      //     // this.redBarChart.chartData.datasets[0].data = data[0]['data']['percentages'];
      //     this.loaded = true;
      //     // this.teammembers = teamMembers;
      //     // console.log(this.stores);
      //     // console.log(this.visitsdata);
      //     // this.initBigChart(this.stores[0]);
      //     // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
      //     // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
      //     // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      // });
      // Promise.all([
      //   store.dispatch(GET_OVERVIEW)
      // ]).then(() => {
      //     this.loaded = true;
      //     // console.log(this.stores);
      //     // console.log(this.visitsdata);
      //     // this.initBigChart(this.stores[0]);
      //     // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
      //     // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
      //     // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      // });

      // function onPubnub(msg) {
      //           for (let i = 0; i < this.overview.length; i++) {
      //             if (this.tableData[i].token === msg.message) {
      //               this.tableData[i].hasLocation = true;
      //               this.tableData[i].status = 2;
      //               this.tableData[i].statusType = 'success';
      //             }
      //           }
      // }

      //  var pubnub = new PubNub({
      //       publishKey: "pub-c-19662d2f-1d79-4568-a018-e352b0af2171",
      //       subscribeKey: "sub-c-9185b126-23bc-11e9-bb27-2e4c7f2c8bda"
      //   });



      //   pubnub.addListener({
      //       status: function(statusEvent) {
      //           if (statusEvent.category === "PNConnectedCategory") {
      //               // publishSampleMessage();
      //           }
      //       },
      //       message: function(msg) {
      //           console.log(msg.message);
      //           onPubnub(msg);

      //       },
      //       presence: function(presenceEvent) {
      //           // handle presence
      //       }
      //   })
      //   pubnub.subscribe({
      //       channels: ['911_channel']
      //   });

        // console.log(this.loaded);
        // this.getSubscribers();
        // console.log(this.loaded);

      // this.loaded = false;
      // console.log(this.subscribers);

        // this.loaded = false;

      // console.log(data);

    },

    methods: {
      expandHeader() {

        if (!this.isExpanded) {
          document.getElementById('expandBtn').innerHTML = "&#x25B2;";

          document.getElementById('headerDescription').style.height = "100px";
          
          this.description_display = this.description;
          this.isExpanded = true;
        }
        else {
          document.getElementById('headerDescription').style.height = "50px";
          document.getElementById('expandBtn').innerHTML = "&#x25BC;";
          this.description_display = this.description.substring(0,50) + "...";
          this.isExpanded = false;
        }
        
      },
      viewPrivateInquiries() {
        if (this.enquirySelected) {
          this.enquirySelected = false;
          this.showEnquiry = false;

        }
        else {
          this.enquirySelected = true;

          Promise.all([
            store.dispatch(GET_INQUIRIES,this.$route.params.token)
          ]).then((data) => {
            console.log(data);
            if (data[0]['errFlag'] == 0) {
              this.inquiries = data[0]['inquiry_messages'];
              this.showEnquiry = true;
              this.isPrivateInquiry = false;
              this.is_private = true;
              this.inquiry_id = "";
            }
          });

        }
      },
      newPrivateInquiry() {
        this.modals.modalinquirybox = true;
        this.is_private = true;
      },
      sendInquiry() {
        let canSend = (this.userType === "team" && JwtService.getIsManager() === 1) || (this.userType === "committee");
        if (canSend){
          // if (this.is_private) {
          //   this.is_public = true;
          // }
          // if (!this.is_private) {
          //   this.is_public = false;
          // }
          // this.is_private = !this.is_private;
          // this.is_public = this.is_private;
          // let isTypeValid = this.is_public || this.is_private;
          // if (String(this.userType) === "team") {
          //   isTypeValid = true;
          //   this.is_public = true;
          // }
          // else if (this.inquiry_id.length > 0) {
          //   isTypeValid = true;
          //   this.is_public = true;
          // }
          if (String(this.inquiry_message) !== "" /*&& isTypeValid*/) {

              let type = this.is_private ? "public" : "private";
              console.log("INQUIRY TYPE");
              console.log(type);

              if (type === "private" && this.userType === "committee") {
                if (this.private_inquiries.length > 0) {
                    this.inquiry_id = this.private_inquiries[0]._id;
                }
              }

              console.log("INQUIRY ID ");
              console.log(this.inquiry_id);



              let formData = {"assignment_id" : UserService.getAssignmentId(), "entity_id" : this.$route.params.entity, "phase" : this.$route.params.phase, "deliverable_id" : this.$route.params.token, "inquiry_message" : this.inquiry_message, "type" : type, "inquiry_id" : this.inquiry_id};
              Promise.all([
                store.dispatch(SEND_INQUIRY, formData),

              ]).then((data) => {
                  this.isLoading = false;
                  console.log("INQUIRY SETN ");
                  if (String(type) === "public") {
                    console.log("PUBLIC RESPONSE");
                    Promise.all([
                      store.dispatch(GET_INQUIRIES,this.$route.params.token)
                    ]).then((data) => {
                      console.log(data);
                      if (data[0]['errFlag'] == 0) {
                        this.inquiries = data[0]['inquiry_messages'];
                      }
                    });
                  }
                  else {
                    console.log("PRIVATE RESPONSE");
                    Promise.all([
                    store.dispatch(GET_PRIVATE_INQUIRIES,this.$route.params.token),
                      store.dispatch(GET_PRIVATE_INQUIRIES,this.$route.params.token)
                    ]).then((data) => {
                      console.log(data);
                      if (data[0]['errFlag'] == 0) {
                        this.private_inquiries = data[0]['data'];
                        if (this.userType === "committee") {
                          if (this.private_inquiries.length > 0) {
                            this.inquiryClicked(this.private_inquiries[0]);
                          }
                        }
                        else {
                          if (this.private_inquiries.length > 0) {
                            for (let i = 0; i < this.private_inquiries.length; i++) {
                              if (this.private_inquiries[i]._id === this.inquiry_id) {
                                this.inquiryClicked(this.private_inquiries[i]);
                                break;
                              }

                            }

                          }
                        }
                      }
                    });
                  }


                  this.inquiry_message = "";



                  if (String(this.language) === "ltr") {
                    this.$notify({
                      type: 'success',
                      title: 'Inquiry sent successfully !'
                    })
                  }
                  else {
                    this.$notify({
                      type: 'success',
                      title: '! تم إرسال الاستفسار بنجاح'
                    })
                  }
                  // console.log("RESPONSE TYPE");
                  // console.log(type);

                  // this.is_public = false;
                  // this.is_private = false;
                  // this.modals.modalinquirybox = false;
              });

          }
          else {
            if (String(this.language) === "ltr") {
              this.$notify({
                    type: 'warning',
                    title: 'Please fill in all required fields'
                  })
            }
            else {
              this.$notify({
                    type: 'warning',
                    title: 'يرجى تعبئة جميع الحقول المطلوبة'
                  })
            }
          }
        }
        else {
          if (String(this.language) === "ltr") {
            this.$notify({
                  type: 'warning',
                  title: 'You are not allowed to send a message'
                })
          }
          else {
            this.$notify({
                  type: 'warning',
                  title: 'لا يسمح لك بإرسال رسالة'
                })
          }
        }




      },
      inquiryClicked(inquiry) {
        console.log("INQUIRY CLICKED");
        console.log(inquiry);
        this.inquiry_id = inquiry._id;
        Promise.all([
          store.dispatch(GET_INQUIRY_BY_ID, inquiry._id)
        ]).then((data) => {
          console.log(data);
          if (data[0]['errFlag'] == 0) {
            this.inquiries = data[0]['inquiry_messages'];
            this.inquiry_id = inquiry._id;
            this.showEnquiry = true;
            this.is_private = false;
            this.isPrivateInquiry = true;
            // this.viewPrivateInquiries();
            // this.modals.modal9 = false;
            // this.modals.modalinquirybox = true;
          }
        });
      },
      openInquiryBox() {
        this.inquiry_id = "";
        console.log("CLICKED 123lk1j23l12kj3");
        let formData = {'entity_id' : this.$route.params.entity, 'deliverable_id' : this.$route.params.token};
        console.log(formData);
        Promise.all([
          store.dispatch(GET_ALL_INQUIRIES, formData)
        ]).then((data) => {
          console.log(data);
          if (data[0]['errFlag'] == 0) {
            if (data[0]['public_inquiries'].length == 0 && data[0]['private_inquiries'].length == 0) {
              this.modals.modalinquirybox = true;
              this.modals.modal9 = false;
            }
            else {
              this.public_inquiries = data[0]['public_inquiries'];
              this.private_inquiries = data[0]['private_inquiries'];
              this.modals.modal9 = true;
            }

          }
        });

      },
      back() {
        window.history.back();
        // this.$router.push({ name: 'sendsms' });
      },
      newPublicChat() {
        this.modals.modal9 = false;
        if (Number(this.chats.length) === 0) {
          this.isNewChat = true;
          this.chatType = "public";
          document.getElementById("chat").style.visibility = "visible";
          this.openChat();
          this.chatTitle = "Public Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
        }
        else {
          this.isNewChat = false;
          this.chatType = "public";
          document.getElementById("chat").style.visibility = "visible";
          let isChatFound = false;
          for (let i = 0 ; i < this.chats.length; i++) {
            console.log(this.chats[i]);
              if (this.chats[i].type === "public") {
                this.messageList = this.chats[i].messages;
                this.chatId = this.chats[i].id;
                this.participants = this.chats[i].participants;
                isChatFound = true;
                break;
              }
          }
          if (!isChatFound) {
            this.messageList = [];
            this.chatId = "";
            this.participants = [];
          }
          this.openChat();
          this.chatTitle = "Public Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
        }
      },
      newPrivateChat() {
        this.modals.modal9 = false;
        if (Number(this.chats.length) === 0) {
          this.isNewChat = true;
          this.chatType = "private";
          document.getElementById("chat").style.visibility = "visible";
          this.openChat();
          this.chatTitle = "Private Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
        }
        else {
          this.isNewChat = false;
          this.chatType = "private";
          document.getElementById("chat").style.visibility = "visible";
          let isChatFound = false;
          for (let i = 0 ; i < this.chats.length; i++) {
              if (this.chats[i].type === "private") {
                this.messageList = this.chats[i].messages;
                this.chatId = this.chats[i].id;
                this.participants = this.chats[i].participants;
                isChatFound = true;
                break;
              }
          }
          if (!isChatFound) {
            this.messageList = [];
            this.chatId = "";
            this.participants = [];
          }

          this.openChat();
          this.chatTitle = "Private Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
        }
      },
      onClick(chat) {
        // this.isChatHidden = true;

        // document.getElementById("chatsModal").childNodes[0].childNodes[0].style = 'background-color: #ffffff;opacity: 0.0;';
        this.modals.modal9 = false;
        this.messageList = chat.messages;
        this.chatId = chat.id;
        this.participants = chat.participants;
        // this.chatType = chat.type;
        console.log(chat);
        document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = chat.title;
        document.getElementById("chat").style.visibility = "visible";


        this.openChat();
      },
      openChatModal() {
        if (this.modals.modal9) {
          this.modals.modal9 = false;
        }
        else {

          Promise.all([
            store.dispatch(GET_CHATS)
          ]).then((data) => {
            console.log(data[0]['data']);
              if (data[0]['data']) {
                  this.chats = data[0]['data'];
              }
              else {
                this.chats = [];
              }

              this.modals.modal9 = true;

          });

        }
      },
      sendMessage (text) {
        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
      if (text.length > 0) {
        if (this.isNewChat) {
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(CREATE_CHAT);
          Promise.all([
            store.dispatch(CREATE_CHAT, formData)
          ]).then(() => {
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
        }
        else {
          // Promise.all([
          //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
          // ]).then(() => {
          //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          // });
        }

      }
    },
    onMessageWasSent (message) {
      let canSend = (this.userType === "team" && JwtService.getIsManager() === 1) || (this.userType === "committee");
      if (canSend) {
        console.log(message);
        message.author = UserService.getUserId();
        // called when the user sends a message

        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
        if (message.data.text.length > 0) {
        if (this.isNewChat) {
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(CREATE_CHAT);
          Promise.all([
            store.dispatch(CREATE_CHAT, formData)
          ]).then((data) => {
            this.chatId = data[0]['chatId'];
            this.isNewChat = false;
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            message.author = "me";
            this.messageList = [ ...this.messageList, message ]
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
        }
        else {
          message.author = UserService.getUserId();
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'chat_id' : this.chatId,  'text' : message.data.text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(SEND_MESSAGE);
          Promise.all([
            store.dispatch(SEND_MESSAGE, formData)
          ]).then(() => {
            this.isNewChat = false;
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            message.author = "me";
            this.messageList = [ ...this.messageList, message ]
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
          // Promise.all([
          //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
          // ]).then(() => {
          //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          // });
        }

        }
      }

    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0

      // document.getElementById("chat").childNodes[1].style['margin-right'] = '100px';
      // if (document.getElementById("chat").childNodes[1].childNodes) {
      //   console.log("FOUND CHILD NODES");
      //   // console.log(document.getElementById("chat").childNodes[1].childNodes);
      //   for (let i =0 ; i < document.getElementById("chat").childNodes[1].childNodes.length; i++) {
      //     // console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
      //     if (i == 1) {
      //       console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
      //       for (let g = 0; g < document.getElementById("chat").childNodes[1].childNodes[i].childNodes.length; g++) {
      //         document.getElementById("chat").childNodes[1].childNodes[i].childNodes[g].style = 'margin-right : 100px';
      //       }
      //
      //     }
      //     if (document.getElementById("chat").childNodes[1].childNodes[i].style) {
      //         document.getElementById("chat").childNodes[1].childNodes[i].style['margin-right'] = '100px';
      //     }
      //     else {
      //       document.getElementById("chat").childNodes[1].childNodes[i].style = 'margin-right : 100px';
      //     }
      //
      //   }
      // }
      // else {
      //   console.log("NO CHILD NODES");
      // }
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType () {
      console.log('Emit typing event')
    },
    editMessage(message){
      const m = this.messageList.find(m=>m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
      onPubnub(msg) {
                for (let i = 0; i < this.tableData.length; i++) {
                  this.tableData.push(msg.message);
                  // if (this.tableData[i].token === msg.message) {
                  //   this.tableData[i].hasLocation = true;
                  //   this.tableData[i].status = 2;
                  //   this.tableData[i].statusType = 'success';
                  // }
                }
      },

      onSubmit() {
        // console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            if (this.phone_no !== '' ) {
                this.localerrors = null;


                let formData = {'phone_no':this.phone_no};
                console.log(formData);
                Promise.all([
                  store.dispatch(SEND_SMS, formData),

                ]).then(() => {
                    this.isLoading = false;

                });
            }
            else {

              this.localerrors = "Phone cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
      onChange(event) {
          this.timeslot = event.target.value;
          console.log(event);
      },

      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      }
    }
  };
</script>

<style>

</style>
